import * as React from 'react';
import { Facet } from '@elastic/react-search-ui';
import classnames from 'classnames';

// Renders a facet as a native single-select <select>. Selecting a value replaces any current
// selection; the empty option clears the facet. filterType stays 'any' to match the other
// facet widgets, but only one value is ever selected at a time.
export default function OpenSearchSelectFacet(props) {
  const {field, label, show, hidden = false} = props;

  const css = {
    root: classnames({
      'facet': true,
      'facet--select': true,
      'facet--hidden': hidden,
    }),
  };

  return (
    <div className={css.root}>
      <details open={true}>
        <summary>
          <span>{label}</span>
          <div className='facet__arrow'></div>
        </summary>
        <Facet field={field} show={show} label={label} filterType='any' view={({options, onSelect, onRemove}) => {
          const selected = options.find(option => option.selected);

          const handleChange = (event) => {
            const {value} = event.target;
            // Clear any current selection, then apply the new one (empty = "Any").
            options.forEach(option => {
              if (option.selected) onRemove(option.value);
            });
            if (value) onSelect(value);
          };

          return (
            <fieldset className='sui-facet'>
              <select
                className='form-control form-control-sm facet__select'
                value={selected ? selected.value : ''}
                onChange={handleChange}>
                <option value=''>{label}</option>
                {options.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.value} ({option.count})
                  </option>
                ))}
              </select>
            </fieldset>
          );
        }}/>
      </details>
    </div>
  );
}
